import { Card, CardActionArea, Box, Typography } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

type TileButtonProps = {
    title: string;
    description?: string;
    icon?: React.ReactNode;
    onClick: () => void;
};

export function TileButton({
    title,
    description,
    icon,
    onClick,
}: TileButtonProps) {
    return (
        <Card
            elevation={3}
            sx={{
                height: 180,
                borderRadius: 3,
                transition: "all 0.25s ease",
                "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: 8,
                },
            }}
        >
            <CardActionArea
                onClick={onClick}
                sx={{
                    height: "100%",
                    p: 3,
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        mr: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 64,
                        height: 64,
                        borderRadius: "16px",
                        bgcolor: "primary.main",
                        color: "primary.contrastText",
                        flexShrink: 0,
                    }}
                >
                    {icon ?? <PlayCircleOutlineIcon fontSize="large" />}
                </Box>

                <Box>
                    <Typography variant="h6" fontWeight={600}>
                        {title}
                    </Typography>

                    {description && (
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mt: 0.5 }}
                        >
                            {description}
                        </Typography>
                    )}
                </Box>
            </CardActionArea>
        </Card>
    );
}
